import { useLocation } from 'react-router';

export const useAuthLinksWithReturnUrl = () => {
  const { pathname, search } = useLocation();

  const returnUrl = `${pathname}${search}`;

  return {
    loginUrl: `/oauth/login/?returnUrl=${encodeURIComponent(returnUrl)}`,
    googleLoginUrl: `/oauth/login/?returnUrl=${encodeURIComponent(
      returnUrl,
    )}&strategy=google`,
    registerUrl: `/oauth/register/?returnUrl=${encodeURIComponent(returnUrl)}`,
  };
};
